var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"props":_vm.districtProps,"options":_vm.districtList,"clearable":"","placeholder":"选择区域"},on:{"change":_vm.Change},model:{value:(_vm.districtId),callback:function ($$v) {_vm.districtId=$$v},expression:"districtId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }